import './Footer.css';

export default function Footer() {
  return (
    <div className="footer" id="footer">
      <div className="footer-brand-strip">
        <span className="footer-eyebrow">Tegus Bagel Co.</span>
        <h2>Síguenos y mantente cerca del bagel drop.</h2>
        <p>
          Tegus Bagel Co. trae energía de New York a Tegucigalpa con desayunos,
          lunch y catering listo para pedir cuando te pegue el antojo.
        </p>
      </div>

      <p className="footer-follow-label">Síguenos en:</p>
      <div className="wrapper">
        <div className="social-media social-media-disabled" aria-label="Instagram link unavailable">
          <div className="icon">
            <i className="fa-brands fa-instagram"></i>
          </div>
          <span>Instagram</span>
        </div>
        <a
          className="social-media"
          href="https://www.facebook.com/profile.php?id=61571575029906"
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook Tegus Bagel Co."
        >
          <div className="icon">
            <i className="fa-brands fa-facebook"></i>
          </div>
          <span>Facebook</span>
        </a>
      </div>
      <span className="footer-credit">
        Un sitio creado con ♥ por <span id="creator-name">© Grupo Saubar</span>
        <br />
        Tegucigalpa, Honduras 2024-2026
      </span>
    </div>
  );
}
